module.exports = __webpack_public_path__ + "static/icons/snowing-6493b8bf5ea0a1cc899c5c3bc40c62e1.png";